import React from "react";
import classNames from "classnames";
import { Menu, MenuButton, MenuItem, MenuItems, MenuProps } from "@headlessui/react";
import { AnchorProps } from "@headlessui/react/dist/internal/floating";
import InViewObserver from "@/component/InViewObserver";
import MoreMenuIcon from "@/assets/svgs/more_menu.svg";


interface PopoverProps extends MenuProps {
    className?: string;
}

export const Popover: React.FC<PopoverProps> = (props) => {
    const {
        className: propsClassName,
        children,
    } = props;

    return (
        <Menu as="div"
              className={classNames(
                  "relative z-20 flex items-center",
                  propsClassName ?? ""
              )}
        >
            {children}
        </Menu>
    );
};

interface PopoverButtonProps {
    className?: string;
    open?: boolean;
    close?: () => void;
    disabled?: boolean;
    "aria-label"?: string;
    children?: React.ReactNode;
}

export const PopoverButton: React.FC<PopoverButtonProps> = (props) => {
    const { className: propsClassName, open, close, children, disabled, "aria-label": ariaLabel } = props;

    return (
        <InViewObserver enabled={open}
                        onHidden={close}
        >{inViewRef => (
            <MenuButton ref={inViewRef}
                        className={classNames(propsClassName ?? "")}
                        disabled={disabled}
                        onClick={e => e.stopPropagation()}
                        aria-label={ariaLabel}
            >
                {children !== undefined ? children : (
                    <img src={MoreMenuIcon} alt="menu" className="size-4" />
                )}
            </MenuButton>
        )}</InViewObserver>
    );
};

interface PopoverMenuProps {
    className?: string;
    anchor?: AnchorProps;
    children: React.ReactNode;
}

export const PopoverMenu: React.FC<PopoverMenuProps> = (props) => {
    const { className: propsClassName, anchor, children } = props;

    return (
        <MenuItems transition
                anchor={anchor ?? "left start"}
                className={classNames(
                    "w-fit bg-white rounded-[6px] shadow-black-200 shadow-btn-sm outline-none",
                    "absolute z-50 origin-top-right py-0.5",
                    "transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0",
                    propsClassName
                )}
                onClick={e => e.stopPropagation()}
        >
            {children}
        </MenuItems>
    );
};

interface PopoverItemProps {
    className?: string;
    disabled?: boolean;
    onClick: (e: React.MouseEvent) => void | Promise<void>;
    children: React.ReactNode;
}

export const PopoverItem: React.FC<PopoverItemProps> = (props) => {
    const { className: propsClassName, children, disabled, onClick } = props;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onClick(e);
    };

    return (
        <MenuItem as="button"
                  className={classNames("popover-item popover-text-500", propsClassName ?? "")}
                  disabled={disabled}
                  onClick={handleClick}
        >
            {children}
        </MenuItem>
    );
};
